/**************************************************
 * Nombre:       Dialogo_Contrato_Crear
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../../Recursos/logo_redondo.svg'
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../../Servicios/BD/borrarDoc";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Contrato_Crear from "../../Formularios/Contratos/Formulario_Contrato_Crear";
import {crearContratoNoMovimiento} from "../../../CodNegocio/Contratos/crearContratoNoMovimiento";

const Dialogo_Contrato_Crear = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()


        iniciarCarga('Creando contratos sin bono')
        let usuario = {
            id: entidad.idUsuario,
            nombre: entidad.nombre,
            correo: entidad.correo,
            codigo: entidad.codigoUsuario,
        }

        let enti = {
            valor: entidad.valor,
        }

        //console.log(usuario)


        let dox = await crearContratoNoMovimiento({entidad: enti, usuario: usuario})
        if (dox.res) {
            terminar({aviso: 'Contrato realizado con exito'})
        } else {
            terminar({aviso: dox.data, variante: 'error'})
        }

    }

    const borrar = async () => {
        await borrarDoc('contratos', datos.id)
        terminar({aviso: 'Contrato borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Contrato_Crear props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Contrato_Crear